import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

// The generated Supabase types don't include this RPC yet.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const db = supabase as any;

/**
 * Whether a tenant site shows "Powered by The Polished Version" in its footer.
 * Solo and Team always do; Business can switch it off. The database applies the
 * plan rule (public.org_shows_powered_by), so a downgrade brings it back.
 * Anything that goes wrong means "show it".
 */
export function useShowsPoweredBy(orgId: string | null | undefined) {
  return useQuery({
    queryKey: ['org-shows-powered-by', orgId],
    enabled: Boolean(orgId),
    staleTime: 60_000,
    queryFn: async (): Promise<boolean> => {
      const { data, error } = await db.rpc('org_shows_powered_by', { _org: orgId });
      if (error) {
        console.warn('Could not read footer credit setting', error);
        return true;
      }
      return data !== false;
    },
  });
}
